export default "/images/6af52f7792b39a933c22a57aa2c3885d.png";